import chartOption3AxisLenControlPlugin from "./plugins/chartOption3AxisLenControlPlugin"
import formaterStringToFuncPlugin from "./plugins/formaterStringToFuncPlugin"
import formaterValToAbsPlugin from "./plugins/formaterValToAbsPlugin"
import formaterControlLenPlugin from "components/bigScreenComponents/commonPlugins/formaterControlLenPlugin"
export default {
  mixins: [
    chartOption3AxisLenControlPlugin,
    formaterStringToFuncPlugin,
    formaterValToAbsPlugin,
    formaterControlLenPlugin
  ]
}
